const baseURL = {
    local: 'https://test-svc.ecal.com',
    test: 'https://test-svc.ecal.com',
    stage: 'https://stage-svc.ecal.com',
    prod: 'https://svc.ecal.com',
};

export default baseURL;
